import "./UserBannerInfoRow.css";
import { Text } from "@chakra-ui/react";

export const UserInfoBannerRow = ({ props }) => {
  // Determine if value is key (IP, City, Country)
  // Check by localization keys and text for compatibility
  const isKeyValue = props.label && (
    props.label.toLowerCase().includes('ip') ||
    props.label.toLowerCase().includes('city') ||
    props.label.toLowerCase().includes('country')
  );

  return (
    <>
      <div className="info-banner-row">
        <div className="info-banner-row-label">
          <Text fontSize="13px" fontWeight={500} color="text.secondary">
            {props.label}:
          </Text>
        </div>
        <div className="info-banner-row-right">
          <div className="info-banner-row-icon">{props.icon}</div>
          <div className="info-banner-row-text">
            <Text fontSize="14px" fontWeight={400} color={isKeyValue ? "brand.solid" : undefined}>
              {props.text}
            </Text>
          </div>
        </div>
      </div>
    </>
  );
};
